import { CheckBoxCell } from '@med-fe/ui';

export const hr_columns = [
  {
    title: 'Location number',
    dataIndex: 'locationNumber',
    key: 'action',
    width: 60,
    fixed: 'left',
  },
  {
    title: 'Location name',
    dataIndex: 'locationName',
    key: 'locationName',
    width: 100,
  },
  {
    title: 'Employee name',
    dataIndex: 'employeeName',
    key: 'employeeName',
    width: 100,
  },
  {
    title: 'Employee email',
    dataIndex: 'employeeEmail',
    key: 'employeeEmail',
    width: 120,
  },
  {
    title: 'Doctor Location Grouping',
    dataIndex: 'doctorLocationGrouping',
    key: 'doctorLocationGrouping',
    width: 100,
  },
  {
    title: 'Stipend',
    dataIndex: 'stipend',
    key: 'stipend',
    width: 60,
    colType: 'checkbox',
    render: (value: boolean) => <CheckBoxCell value={value} />,
  },
  {
    title: 'Pathways',
    dataIndex: 'pathways',
    key: 'pathways',
    width: 60,
    colType: 'checkbox',
    render: (value: boolean) => <CheckBoxCell value={value} />,
  },
  {
    title: 'Tuition Reimbursement',
    dataIndex: 'tuitionReimbursement',
    key: 'tuitionReimbursement',
    width: 80,
    colType: 'checkbox',
    render: (value: boolean) => <CheckBoxCell value={value} />,
  },
];
